import { render } from "./CardItem.vue?vue&type=template&id=07a8b2b1&scoped=true"
import script from "./CardItem.vue?vue&type=script&lang=ts"
export * from "./CardItem.vue?vue&type=script&lang=ts"

import "./CardItem.vue?vue&type=style&index=0&id=07a8b2b1&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-07a8b2b1"

export default script